import React, {useEffect} from 'react';
import BannerAboutUs from '../AboutUs/BannerAboutUs/index'
import CualidadesEmpresa from '../AboutUs/CualidadesEmpresa/index'


export default function AboutUs(props){

   
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

    return(<>
     <div style={{height: '20px'}}></div>
    <BannerAboutUs/>
    <div style={{height: '20px'}}></div>
    <CualidadesEmpresa/>
    <div style={{height: '20px'}}></div>
    </>)
}